export const ADD_SEGMENTATIONS = 'ADD_SEGMENTATIONS';
export const ADD_NEW_SEGMENTATION = 'ADD_NEW_SEGMENTATION';
export const ADD_SEGMENTATIONS_BY_VOLUME_3D = 'ADD_SEGMENTATIONS_BY_VOLUME_3D';
export const ADD_SEED = 'ADD_SEED';
export const REMOVE_SEED = 'REMOVE_SEED';
export const UPDATE_SENSITIVITY = 'UPDATE_SENSITIVITY';
